const VerifoneSocketNames = Object.freeze({
    INTEGRATION: 'Integration Socket',
    PROGRESS: 'Progress Socket'
});

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = VerifoneSocketNames;
}
